import React, { useEffect, useRef } from 'react';
import EditorJS from '@editorjs/editorjs';
import { Button } from '@mui/material';
// import Header from '@editorjs/header';
// import List from '@editorjs/list';

const EditorComponent = ({ editorData, setEditorData }) => {
  const editorRef = useRef(null);
  const editorInstance = useRef(null);

  useEffect(() => {
    editorInstance.current = new EditorJS({
      holder: editorRef.current,
      autofocus: true,
      data: editorData ? JSON.parse(editorData) : {},
      tools: {
        // header: Header,
        // list: List,
      },
    });

    return () => {
      editorInstance.current.isReady
        .then(() => {
          editorInstance.current.destroy();
        })
        .catch((e) => console.error('ERROR editor cleanup', e));
    };
  }, []);

  useEffect(() => {
    if (editorInstance.current && editorData) {
      editorInstance.current.isReady
        .then(() => {
          editorInstance.current.blocks.render({ blocks: JSON.parse(editorData).blocks });
        })
        .catch((error) => {
          console.error('Error rendering new data:', error);
        });
    }
  }, [editorData]);

  const logData = () => {
    editorInstance.current
      .save()
      .then((outputData) => {
        setEditorData(JSON.stringify(outputData));
      })
      .catch((error) => {
        console.error('Saving failed:', error);
      });
  };

  return (
    <div className="border">
      <div id="editorjs" ref={editorRef}></div>
      <Button onClick={logData} variant="contained" sx={{ m: 3 }}>
        ذخیره تغییرات
      </Button>
    </div>
  );
};

export default EditorComponent;
